var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-col',[_c('v-row',{attrs:{"justify":"center"}},[_vm._v(_vm._s(_vm.Data))]),_c('v-row',{attrs:{"justify":"center"}},[_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.Title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }